import { useCallback } from 'react';
import { useGame } from '../context/GameContext';
import { usePlayer } from '../context/PlayerContext';
import { useFirebaseSync } from './useFirebaseSync';

function useGameState() {
  const { state, dispatch } = useGame();
  const { playerId } = usePlayer();

  const syncPath = state.roomCode ? `rooms/${state.roomCode}` : null;

  const handleSync = useCallback(
    (data) => {
      if (!data) return;

      const payload = {
        gameState: data.gameState || state.gameState,
        players: data.players || {},
        playerOrder: data.playerOrder || [],
        currentTurn: data.currentTurn || null,
        discardPile: data.discardPile || { topCard: null, count: 0 },
        deckRemaining: data.deck?.remaining || 0,
        roundState: data.roundState || null,
        cardBack: data.cardBack || 'classic',
        customCardBack: data.customCardBack || null,
      };

      dispatch({ type: 'SYNC_GAME_STATE', payload });
    },
    [dispatch, state.gameState]
  );

  useFirebaseSync(syncPath, handleSync);

  const myHand = state.players[playerId]?.hand
    ? Object.values(state.players[playerId].hand)
    : [];

  const isMyTurn = state.currentTurn?.playerId === playerId;

  return {
    ...state,
    myHand,
    isMyTurn,
  };
}

export { useGameState };
